// Order matches the 39 skill rows on the character sheet PDF exactly (see Finalize.js's
// Skills region) so the two stay in lockstep.
const skills = [
	{ key: 'acrobatics', name: 'Acrobatics', ability: 'dex' },
	{ key: 'appraise', name: 'Appraise', ability: 'int' },
	{ key: 'bluff', name: 'Bluff', ability: 'cha' },
	{ key: 'climb', name: 'Climb', ability: 'str' },
	{ key: 'craft1', name: 'Craft', ability: 'int', specialization: true },
	{ key: 'craft2', name: 'Craft', ability: 'int', specialization: true },
	{ key: 'craft3', name: 'Craft', ability: 'int', specialization: true },
	{ key: 'diplomacy', name: 'Diplomacy', ability: 'cha' },
	{ key: 'disableDevice', name: 'Disable Device', ability: 'dex', trainedOnly: true },
	{ key: 'disguise', name: 'Disguise', ability: 'cha' },
	{ key: 'escapeArtist', name: 'Escape Artist', ability: 'dex' },
	{ key: 'fly', name: 'Fly', ability: 'dex' },
	{ key: 'handleAnimal', name: 'Handle Animal', ability: 'cha', trainedOnly: true },
	{ key: 'heal', name: 'Heal', ability: 'wis' },
	{ key: 'intimidate', name: 'Intimidate', ability: 'cha' },
	{ key: 'knowledgeArcana', name: 'Knowledge (Arcana)', ability: 'int', trainedOnly: true },
	{ key: 'knowledgeDungeoneering', name: 'Knowledge (Dungeoneering)', ability: 'int', trainedOnly: true },
	{ key: 'knowledgeEngineering', name: 'Knowledge (Engineering)', ability: 'int', trainedOnly: true },
	{ key: 'knowledgeGeography', name: 'Knowledge (Geography)', ability: 'int', trainedOnly: true },
	{ key: 'knowledgeHistory', name: 'Knowledge (History)', ability: 'int', trainedOnly: true },
	{ key: 'knowledgeLocal', name: 'Knowledge (Local)', ability: 'int', trainedOnly: true },
	{ key: 'knowledgeNature', name: 'Knowledge (Nature)', ability: 'int', trainedOnly: true },
	{ key: 'knowledgeNobility', name: 'Knowledge (Nobility)', ability: 'int', trainedOnly: true },
	{ key: 'knowledgePlanes', name: 'Knowledge (Planes)', ability: 'int', trainedOnly: true },
	{ key: 'knowledgeReligion', name: 'Knowledge (Religion)', ability: 'int', trainedOnly: true },
	{ key: 'linguistics', name: 'Linguistics', ability: 'int', trainedOnly: true },
	{ key: 'perception', name: 'Perception', ability: 'wis' },
	{ key: 'perform1', name: 'Perform', ability: 'cha', specialization: true },
	{ key: 'perform2', name: 'Perform', ability: 'cha', specialization: true },
	{ key: 'profession1', name: 'Profession', ability: 'wis', specialization: true, trainedOnly: true },
	{ key: 'profession2', name: 'Profession', ability: 'wis', specialization: true, trainedOnly: true },
	{ key: 'ride', name: 'Ride', ability: 'dex' },
	{ key: 'senseMotive', name: 'Sense Motive', ability: 'wis' },
	{ key: 'sleightOfHand', name: 'Sleight of Hand', ability: 'dex', trainedOnly: true },
	{ key: 'spellcraft', name: 'Spellcraft', ability: 'int', trainedOnly: true },
	{ key: 'stealth', name: 'Stealth', ability: 'dex' },
	{ key: 'survival', name: 'Survival', ability: 'wis' },
	{ key: 'swim', name: 'Swim', ability: 'str' },
	{ key: 'useMagicDevice', name: 'Use Magic Device', ability: 'cha', trainedOnly: true },
];

export default skills;
